import React from 'react'
import { Title } from '../helpers/Helper'
import { MenuContainer, MenuGrid, MenuItem } from './menuStyle'
import * as data from './menuData'

export default function Menu() {
  return (
    <MenuContainer id='menu'>
      <Title>Menú</Title>
      <MenuGrid>
        {
          data.Dish.map(({id, title, img, description, price}) => {
            return (
              <MenuItem key={id}>
                <h3>{title}</h3>
                <img src={img} alt="menu" />
                <p>{description}</p>
                <span>{price}</span>
              </MenuItem>
            )
          })
        }
      </MenuGrid>
    </MenuContainer>
  )
}
